import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { initBridge } from './bridge.js';
import { useStore } from './store.js';
import './styles.css';

const root = createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

initBridge()
  .then((bridge) => useStore.getState().connect(bridge))
  .catch((err) => {
    useStore.setState({ error: `Could not start: ${(err as Error).message}` });
  });
